import { useResolvedAccessLevel } from '../../components/PermissionsContainer';

/**
 * Component id for the order-level Street Turn Review (the `mule` column) gate.
 *
 * Unlike the order-lc-fields grouping, Street Turn Review is read-only for LCs
 * AND Dispatchers and editable only by LC MANAGERS — so it gets its own component
 * permission (an admin grants the LC-Manager group edit access on
 * `street-turn-review` independently of the LC field gate), like railbill-flag.
 */
export const STREET_TURN_REVIEW_COMPONENT_ID = 'street-turn-review';

/**
 * Whether the current user may edit the order's Street Turn Review value.
 *
 * Resolved from the admin-configured component permission crossed with the
 * user's Azure AD groups. Ships **defaultDisabled**: until an admin grants a
 * group edit access on `street-turn-review`, it stays read-only for everyone.
 */
export const useCanEditStreetTurnReview = (): boolean =>
  useResolvedAccessLevel(STREET_TURN_REVIEW_COMPONENT_ID, false, true) >= 2;
